import styled from "styled-components";
import { cover } from "polished";

import { fluidType } from "src/utils";

const RichText = styled.div`
  color: ${props => props.theme.colors.text.default};
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    &:not(:first-child) {
      margin-top: 1.25em;
    }
  }
  h1 {
    ${fluidType(5)};
    font-weight: 700;
    letter-spacing: -0.0125em;
    line-height: 1.15;
    color: ${props => props.theme.colors.brand.purple};
    &:not(:last-child) {
      margin-bottom: 0.25em;
    }
  }
  h2 {
    ${fluidType(4)};
    font-weight: 700;
    letter-spacing: -0.0125em;
    line-height: 1.2;
    color: ${props => props.theme.colors.brand.purple};
    &:not(:last-child) {
      margin-bottom: 0.25em;
    }
  }
  h3 {
    ${fluidType(3)};
    font-weight: 700;
    letter-spacing: -0.0125em;
    line-height: 1.2;
    color: ${props => props.theme.colors.brand.purple};
    &:not(:last-child) {
      margin-bottom: 0.25em;
    }
  }
  h4 {
    ${fluidType(2)};
    font-weight: 700;
    letter-spacing: -0.0125em;
    line-height: 1.2;
    color: ${props => props.theme.colors.brand.purple};
    &:not(:last-child) {
      margin-bottom: 0.25em;
    }
  }
  h5 {
    ${fluidType(1.25)};
    font-weight: 700;
    letter-spacing: -0.0125em;
    line-height: 1.2;
    color: ${props => props.theme.colors.brand.purple};
    &:not(:last-child) {
      margin-bottom: 0.25em;
    }
  }
  h6 {
    ${fluidType(1)};
    font-weight: 700;
    letter-spacing: 0.075em;
    line-height: 1.3;
    text-transform: uppercase;
    color: ${props => props.theme.colors.brand.purple};
    &:not(:last-child) {
      margin-bottom: 0.25em;
    }
  }
  p {
    margin: 0;
    ${fluidType(1.25)};
    line-height: 1.3;
    /* &:not(:last-child) {
      margin-bottom: 1em;
    } */
  }
  p + p,
  ul + p,
  ol + p {
    margin-top: 1em;
  }
  a {
    text-decoration: underline;
  }
  ol,
  ul {
    margin: 0;
    ${fluidType(1.25)};
    line-height: 1.3;
    /* &:not(:last-child) {
      margin-bottom: 1em;
    } */
  }
  [data-oembed-type="video"] {
    div {
      position: relative;
      margin: 16px 0;
      padding-bottom: ${(270 / 480) * 100}%;
      iframe {
        ${cover()};
        width: 100%;
        height: 100%;
      }
    }
  }
  blockquote {
    margin: 0;
    margin-left: 2.5rem;
    ${fluidType(1.25)};
    color: ${props => props.theme.colors.brand.purple};
    white-space: inherit;
    font-family: ${props => props.theme.fonts.sans};
    hanging-punctuation: first;

    &::before {
      content: "“";
      color: ${props => props.theme.colors.brand.purple};
    }
    &::after {
      content: "”";
      color: ${props => props.theme.colors.brand.purple};
    }
  }
  .block-img {
    width: 100%;
    img {
      max-width: 100%;
    }
  }
`;

export default RichText;
